import AxiosBaseService from "./axiosBaseService";
import axios from "axios";


export default class AxiosVideoService extends AxiosBaseService {


    createVideo(token: string, video_url: string, lang: string, slang: string, ) {
        return this.post(`${this.serverUrl}/video`, {"video_url": video_url, "language": lang, "site_language": slang}, {authToken: token}
        )
    }
    createVideoWithAudio(
    video_url: string,
    lang: string,
    slang: string,
    audio_file: File,
    token?: string
    ) {
    const formData = new FormData();

    formData.append("video_url", video_url);
    formData.append("language", lang);
    formData.append("site_language", slang);
    formData.append("audio_file", audio_file); // 一定要是 File

    return this.post(
        `${this.serverUrl}/video/upload`,
        formData,
        {
        authToken: token,
        headers: {
            "Content-Type": "multipart/form-data",
        },
        }
    );
    }

    getVideoById(id: string, filter? : any) {
        return this.get(`${this.serverUrl}/video/${id}${filter ? filter : ''}`, {})
    }
    deleteVideo(token: string, id: string) {
        return this.delete(`${this.serverUrl}/video/${id}`, {authToken: token})
    }

    //All Videos List with filter
    getVideosAll(filter?: string) {
        return this.get(`${this.serverUrl}/video?size=1500${filter ? filter : ''}`, {})
    }
    //All Videos List with filter & pagination
    getVideos(page: number, size: number, filter?: string) {
        return this.get(`${this.serverUrl}/video?page=${page}&size=${size}${filter ? filter : ''}`, {})
    }
    //Videos History List
    getVideoList(token: string, page: number, size: number, learning_language: string, transcribeStatuses: string[] = []) {
        const statusQuery = transcribeStatuses.map((status) => `&transcribe_status=${status}`).join('')
        return this.get(`${this.serverUrl}/video/list?pageNumber=${page}&pageSize=${size}&learning_language=${learning_language}${statusQuery}`, {authToken: token})
    }

    patchVideo(token: string, secret_key: string, id: string) {
        return this.patch(`${this.serverUrl}/video/${secret_key}`, {"id": id}, {authToken: token}
        )
    }
    patchVideoTranscipt(token: string, id: string, transcript: any) {
        return this.patch(`${this.serverUrl}/video`, {"transcript": transcript, "id": id}, {authToken: token}

        )
    }
    VocabaryLookUp(token: string, content: any) {
        return this.post(`${this.serverUrl}/video/vocabulary`, content,  {authToken: token})
    }

    //Vocabularies History Lists
    VocabularyHistoryListAll(token: string) {
        return this.get(`${this.serverUrl}/vocabulary`,  {authToken: token})
    }
    VocabularyHistoryList(token: string, page: number, size: number, learning_language: string) {
        return this.get(`${this.serverUrl}/vocabulary?pageNumber=${page}&pageSize=${size}&learning_language=${learning_language}`,  {authToken: token})
    }
    
    //Vocabularies Saved List
    VocabularyList(token: string, page: number, size: number, learning_language: string) {
        return this.get(`${this.serverUrl}/vocabulary?pageNumber=${page}&pageSize=${size}&learning_language=${learning_language}&is_saved=true`,  {authToken: token})
    }
    //Sentence Saved List
    saveSentence(token: string, sentence: any) {
        return this.post(`${this.serverUrl}/video/sentence`, sentence, {authToken: token}
        )
    }
    //Patch Sentence
    patchSentence(token: string, id: string, count: number) {
        return this.patch(`${this.serverUrl}/video/sentence/${id}`, { "click_count": count}, {authToken: token}
        )
    }
    //Delete Sentence
    deleteSentence(token: string, id: string) {
        return this.delete(`${this.serverUrl}/video/sentence/${id}`, {authToken: token}
        )
    }
    //Sentences Lists
    SentenceList(token: string, page: number, size: number, learning_language: string) {
        return this.get(`${this.serverUrl}/video/sentence/list?pageNumber=${page}&pageSize=${size}&learning_language=${learning_language}`,  {authToken: token})
    }
    createCategory(token: string, cat: object){
        return this.post(`${this.serverUrl}/category`, cat ,{authToken: token})
    }
    ListAllCategory(){
        return this.get(`${this.serverUrl}/category`,{})
    }
    patchCategory(token: string, cat: object){
        return this.patch(`${this.serverUrl}/category`, cat ,{authToken: token})
    }
    getCategoryById(id:string){
        return this.get(`${this.serverUrl}/category/${id}`,{})
    }
    deleteCategory(token: string, id:string){
        return this.delete(`${this.serverUrl}/category/${id}`,{authToken: token})
    }
    assignVideoCategory(token: string, id:string, cat: object){
        return this.patch(`${this.serverUrl}/video/video_category/${id}`, cat, {authToken: token})
    }
    // listVideoWithCategory(str: string, page?:number){
    //     return this.get(`${this.serverUrl}/video/video_category/list?${str}&page=${page}&size=24`, {})
    // }
    patchVideoLevel(token: string, param: object){
        return this.patch(`${this.serverUrl}/video`, param, {authToken: token})
    }

}